import * as actions from "../actionTypes"

// pageDocs is { first: <doc>, last: <doc> } for that page, and used by prev/next
const initialState = {
  value: {
    page: 0,
    order: "asc",
    orderBy: "email",
    active_only: true,
    email: "",
  },
}

export default function userGridPagination(state = initialState, action) {
  switch (action.type) {
    case actions.SET_USER_GRID_PAGINATION: {
      return {
        ...state,
        value: action.payload.value,
      }
    }

    default:
      return state
  }
}
